module.exports = __webpack_public_path__ + "img/未标题-99.1cf9e70e.gif";